<template>
<main class="main ">
  <div
									class="d-flex justify-content-between align-items-center flex-column"
								>
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
								<div class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--11 bg-color--light--1">
									<h4 class="mb-3 font-weight-bold">{{$t("register.addressInfo")}}</h4>
									<hr />
									<div class="container">
										
										<br />

										<div class="form-row justify-content-between">
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.province") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ province }}</label
													>
												</div>
											</div>

											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.city") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ city }}</label
													>
												</div>
											</div>
											
										</div>
										

										<div class="form-row justify-content-between">
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.address") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ address }}</label
													>
												</div>
											</div>
											<div class="col-5">
												<div class="form-group">
													<label
														class="form__label text-uppercase font-size--15 font-w--500"
														>{{ $t("register.zipCode") + "  :  " }}</label
													>
													<label
														class="form__label text-uppercase font-size--15 font-w--400"
														>{{ zipCode }}</label
													>
												</div>
											</div>
											
										</div>


										<div class="form-row justify-content-between">

											<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.homeType") + "  :  " }}</label
												>
												<label v-if="homeType==0"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.estate.personal") }}</label
												>
												<label v-if="homeType==1"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.estate.Organizational") }}</label
												>
												<label v-if="homeType==2"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.estate.rental") }}</label
												>
										
											</div>
										</div>
										</div>
										
									</div>
								</div>
								</div>
								</div>
								</main>
										

									
									
							
</template>

<script>
export default {
    data()
    {

        return {
                customer:null,
                province: "",
				city: "",
				address: "",
				zipCode: "",
				homeType:""
        }
    }
    ,
    mounted()
    {
		
		try
		{
			this.customer =JSON.parse( this.$store.getters.getCustomer)
		}
		catch
		{
			this.customer = this.$store.getters.getCustomer
		}
        
		
        this.province = this.customer.province
		this.city = this.customer.city
		this.address = this.customer.address
		this.zipCode = this.customer.postal_code
		this.homeType = this.customer.home_type
		
		
    }

}
</script>

<style>

</style>